import { Stack, SxProps, Typography } from '@mui/material';

export type LandingSectionTitleProps = {
  title?: string | React.ReactNode;
  subtitle?: string;
  sx?: SxProps;
};

export function LandingSectionTitle({ title, subtitle, sx }: LandingSectionTitleProps) {
  return title || subtitle ? (
    <Stack
      spacing={{ xs: '8px', sm: '10px' }}
      direction="column"
      sx={{
        color: 'grey.800',
        ...sx,
      }}
    >
      {title && (
        <Typography
          fontWeight={600}
          fontSize={{ xs: '16px', sm: '20px' }}
          lineHeight={{ xs: '24px', sm: '30px' }}
          component="h2"
        >
          {title}
        </Typography>
      )}

      {subtitle && (
        <Typography
          fontWeight={400}
          fontSize={{ xs: '14px', sm: '16px' }}
          lineHeight={{ xs: '20px', sm: '24px' }}
          sx={{ opacity: 0.5 }}
        >
          {subtitle}
        </Typography>
      )}
    </Stack>
  ) : null;
}
